<template>
  <div>
    <section>
      <h3 class="text-center" style="margin-bottom: 0">You Backed</h3>
    </section>

    <div v-if="backed_standard">
      <ArsenalProduct
        arsenal_model="Standard"
        :show_arsenal_model="!hide_pro"
        :arsenal="order.products.pledge"
        :prices="order.product_prices ? order.product_prices.arsenal_2_standard : prices.arsenal_2_standard"
        limit="1"
        :discount_label="pledge.level"
        disable_cable_select="true"
        show_upgrade_button="true"
        :upgraded_to_pro="upgraded_to_pro"
        :downgrade_to_standard="downgrade_to_standard"
      >
        <ul>
          <li>3x faster than Arsenal 1</li>
        </ul>
      </ArsenalProduct>

      <section v-if="!hide_pro" class="special-offer">
        <h3 class="header">Special Offer</h3>
        <div class="content">
          <p class="line1">Upgrade to Arsenal 2 Pro at the <strong>{{pledge.level}} Price</strong></p>
          <p class="small">Only available to backers of Arsenal 2 Standard at the<br>{{pledge.level}} price.</p>
          <p class="most-popular">
            <img :src="require(`app/assets/images/fire.png`)"/>
            MOST POPULAR
            <img :src="require(`app/assets/images/fire.png`)"/>
          </p>
          <ul class="features">
            <li>5x faster than Arsenal 1</li>
            <li>Weather Resistant design</li>
            <li>USB-C Ports</li>
          </ul>

          <hr />

          <ArsenalProduct
            arsenal_model="Pro"
            :show_arsenal_model=true
            :arsenal="order.products.pledge"
            :prices="order.product_prices ? order.product_prices.arsenal_2_pro : prices.arsenal_2_pro"
            limit="1"
            :discount_label="pledge.level"
            disable_cable_select="true"
            show_upgrade_button="true"
            :upgrade_price="prices.arsenal_2_pro.sale - prices.arsenal_2_standard.sale"
            :upgraded_to_pro="upgraded_to_pro"
            :upgrade_to_pro="upgrade_to_pro"
            :downgrade_to_standard="downgrade_to_standard"
          >
            <template v-slot:upgrade-modal-content>
              <h3 class="text-center">Upgrade Pricing</h3>
              <p style="text-align:right">You backed Arsenal 2 Standard at: {{ format_currency(order.charged_amount) }}</p>
              <p style="text-align:right">Arsenal 2 Pro {{pledge.level}} Price: {{ format_currency(prices.arsenal_2_pro.sale) }}</p>
              <p style="text-align:right; border-top: 1px solid #c7c7cd; padding-top:1em">
                Upgrade to Arsenal 2 Pro cost: {{ format_currency(prices.arsenal_2_pro.sale - prices.arsenal_2_standard.sale) }}
              </p>
            </template>
          </ArsenalProduct>
        </div>
      </section>

      <section>
        <div class="product">
          <div class="cables">
            <h4 style="margin-top: 0">Choose Your Cable</h4>
            <Cables :arsenal_version="2" :arsenal="pledge" :$v="$v.order.products.pledge" />
          </div>
        </div>
      </section>

      <section>
        <h3 class="text-center" style="margin: 0">Would you like to purchase additional Arsenal 2s?</h3>
        <h4 class="text-center" style="margin: 0">Same Discounted <strong>{{pledge.level}}</strong> Pricing</h4>
      </section>
    </div>

    <div v-if="backed_pro">
      <ArsenalProduct
        arsenal_model="Pro"
        :show_arsenal_model=true
        :arsenal="order.products.pledge"
        :prices="prices.arsenal_2_pro"
        :discount_label="pledge.level"
        limit="1"
        :$v="$v.order.products.pledge"
      >
        <ul>
          <li>5x faster than Arsenal 1</li>
          <li>Weather Resistant design</li>
          <li>USB-C Ports</li>
        </ul>
      </ArsenalProduct>

      <section v-if="!hide_pro">
        <p class="text-center most-popular">
          <img :src="require(`app/assets/images/fire.png`)"/>
          SPECIAL OFFER
          <img :src="require(`app/assets/images/fire.png`)"/>
        </p>
        <h3 class="text-center">
          Purchase additional Arsenal 2s at the<br>
          Same Discounted {{pledge.level}} Pricing
        </h3>
      </section>
    </div>

    <section v-if="!hide_pro || backed_standard">
      <ArsenalProduct v-if="!hide_pro"
        arsenal_model="Pro"
        :added="order.products.arsenal_pro.quantity > 0"
        v-on:arsenal_added="arsenal_added = true"
        :arsenal="order.products.arsenal_pro"
        :prices="prices.arsenal_2_pro"
        :discount_label="pledge.level"
        :$v="$v.order.products.arsenal_pro"
        :show_arsenal_model="true"
      >
        <ul>
          <li>5x faster than Arsenal 1</li>
          <li>Weather Resistant design</li>
          <li>USB-C Ports</li>
        </ul>
      </ArsenalProduct>
      <ArsenalProduct
        arsenal_model="Standard"
        :added="order.products.arsenal.quantity > 0"
        v-on:arsenal_added="arsenal_added = true"
        :arsenal="order.products.arsenal"
        :prices="prices.arsenal_2_standard"
        :discount_label="pledge.level"
        :$v="$v.order.products.arsenal"
        :show_arsenal_model="true"
      >
        <ul>
          <li>3x faster than Arsenal 1</li>
        </ul>
      </ArsenalProduct>
    </section>

    <Accessories subheader="Now, choose your accessories" :order="order" :prices="prices" :$v="$v" :continental_usa="continental_usa" />
  </div>
</template>

<script>
import Accessories from "app/components/orders/Accessories";
import ArsenalProduct from "app/components/orders/ArsenalProduct";
import Cables from "app/components/orders/Cables";
import { format_currency } from 'app/helpers/CurrencyHelpers';

export default {
  props: ["order", "prices", "$v", "hide_pro", "continental_usa"],
  data() {
    return {
      upgraded_to_pro: false,
    };
  },
  computed: {
    pledge() {
      return this.order.products.pledge
    },
    backed_standard() {
      return /^Arsenal 2 Standard/.test(this.order.original_pledge)
    },
    backed_pro() {
      return /^Arsenal 2 Pro/.test(this.order.original_pledge)
    },
  },
  methods: {
    format_currency,
    upgrade_to_pro() {
      this.upgraded_to_pro = true
      this.pledge.arsenal_model = 'Arsenal 2 Pro'
    },
    downgrade_to_standard() {
      this.upgraded_to_pro = false
      this.pledge.arsenal_model = 'Arsenal 2 Standard'
    },
  },
  components: { ArsenalProduct, Cables, Accessories },
};
</script>
